import {useParams, useNavigate} from 'react-router-dom';
import styles from './newNotification/newNotification.module.scss';
import {
  GET_NOTIFICATION_BY_ID,
  UPDATE_NOTIFICATIONS,
} from 'graphql/mutations/notifications';
import {useQuery, useMutation} from '@apollo/client';
import {Spin} from 'antd';
import {toast} from 'react-toastify';
import NewNotification from './newNotification';
import {
  HoldingsSnapshots,
  InstrumentTargetedTag,
} from './components/HoldingsSnapshots';

export const UpdateNotification = () => {
  const {id} = useParams();
  const navigate = useNavigate();

  const {data: notificationData, loading} = useQuery(GET_NOTIFICATION_BY_ID, {
    variables: {
      input: {
        notificationId: id,
      },
    },
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
    onError: error => toast.error(error.message),
  });

  const notification = notificationData?.getScheduledNotifications?.data?.[0];
  const isEditMode = !!notification;

  const [updateNotification, {loading: updateNotificationLoading}] =
    useMutation(UPDATE_NOTIFICATIONS, {
      errorPolicy: 'all',
      onError: error => toast.error(error.message),
    });

  const handleUpdate = async payload => {
    updateNotification({
      variables: {
        filters: {
          notificationId: id,
          draft: notification?.draft,
          ...payload,
        },
      },
    }).then(({data: {updatedScheduledNotifications}}) => {
      if (updatedScheduledNotifications.__typename === 'Error') {
        toast.error(updatedScheduledNotifications.message);
      } else {
        toast.success(updatedScheduledNotifications.message);
        navigate('/dashboard/notifications');
      }
    });
  };

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  if (!notification && !loading) {
    return (
      <div className={styles.updateNotification}>
        <h1>Notification not found</h1>
      </div>
    );
  }

  return (
    <NewNotification
      initialNotification={notification}
      isEditMode={isEditMode}
      onSubmit={handleUpdate}
      submitButtonLabel="Update Notification"
      disableButton={updateNotificationLoading}
      pageTitle="Update Notification"
      headerExtra={
        <>
          {notification.instrumentTargeted && <InstrumentTargetedTag />}
          {notification.status === 'SENT' &&
            notification.audience?.portfolioHoldings && (
              <div style={{marginTop: 12}}>
                <h3>Holdings sends</h3>
                <HoldingsSnapshots notificationId={notification.id} />
              </div>
            )}
        </>
      }
    />
  );
};
